import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { IndexedDbService } from '../services/indexed-dbservice.service';

export const authgaurdGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const dbService = inject(IndexedDbService);

  try {
    const userData = await dbService.getData('userInfo');
    
    if (userData) {
      return true;
    } else {
      return router.createUrlTree(['/']);
    }
  } catch (error) {
    console.error('Error reading IndexedDB', error);
    return router.createUrlTree(['/']);
  }
};
